module.exports = __webpack_public_path__ + "files/544a92a7d155c834c8b6322c03eb8632.png";